import React from 'react';

import { SimplePage } from 'common';
import { HeroImage } from '@cp-shared-10/frontend-ui';
import { ContentSection } from '@vwfs-bronson/bronson-react';

export const PrivacyPolicyUi: React.FC<{ privacyPolicy?: SimplePage }> = ({ privacyPolicy }) => {
    if (!privacyPolicy) {
        return null;
    }
    const { teaser, content } = privacyPolicy;

    const teaserComponent = teaser ? (
        <HeroImage title={teaser.title} imageUrl={teaser.imageUrl} shallow={false} />
    ) : null;

    const title = content?.title ? <h1>{content.title}</h1> : null;

    return (
        <>
            {teaserComponent}
            <ContentSection pageWrapSize="medium">
                {title}
                <div dangerouslySetInnerHTML={{ __html: content.text }} />
            </ContentSection>
        </>
    );
};
